import { InputSwitch } from "primereact/inputswitch";
import { Controller, useFormContext } from "react-hook-form";

export function PerDiemToggle() {
  const { control } = useFormContext();

  return (
    <div className="field col-12 md:col-6 p-3">
      <label htmlFor="isPerDiem" className="font-medium mb-2 block">
        Per Diem
      </label>
      <Controller
        name="isPerDiem"
        control={control}
        render={({ field }) => (
          <div className="flex align-items-center gap-2">
            <InputSwitch
              checked={field.value}
              onChange={(e) => field.onChange(e.value)}
            />
            <span className="text-sm text-600">
              Multiply DRG rate by length of stay
            </span>
          </div>
        )}
      />
    </div>
  );
}
